import { TranslationKeys } from '../core/constants/translationKeys';
import { lazyWithRetry } from '../core/helpers/lazyWithRetry';
import { GameIds } from '../core/constants/gameIds';

const LimboGameContent = lazyWithRetry(() => import('../games/limbo'));
const LimboBetContent = lazyWithRetry(() => import('../games/limbo/limboBetContent'));
const LimboGameRules = lazyWithRetry(() => import('../games/limbo/limboGameRules'));
const LimboFairness = lazyWithRetry(() => import('../games/limbo/limboFairness'));
const LimboAboutHash = lazyWithRetry(() => import('../games/limbo/limboFairness/aboutHash'));
const LimboHotKeys = lazyWithRetry(() => import('../games/limbo/limboHotKeys'));

const Limbo10GameContent = lazyWithRetry(() => import('../games/limbo10'));
const Limbo10BetContent = lazyWithRetry(() => import('../games/limbo10/limbo10BetContent'));
const Limbo10GameRules = lazyWithRetry(() => import('../games/limbo10/limbo10GameRules'));
const Limbo10Fairness = lazyWithRetry(() => import('../games/limbo10/limbo10Fairness'));
const Limbo10AboutHash = lazyWithRetry(() => import('../games/limbo10/limbo10Fairness/aboutHash'));
const Limbo10HotKeys = lazyWithRetry(() => import('../games/limbo10/limbo10HotKeys'));

const MinesGameContent = lazyWithRetry(() => import('../games/mines'));
const MinesBetContent = lazyWithRetry(() => import('../games/mines/minesBetContent'));
const MinesGameRules = lazyWithRetry(() => import('../games/mines/minesGameRules'));
const MinesFairness = lazyWithRetry(() => import('../games/mines/minesFairness'));
const MinesAboutHash = lazyWithRetry(() => import('../games/mines/minesFairness/aboutHash'));
const MinesHotKeys = lazyWithRetry(() => import('../games/mines/minesHotKeys'));

const DiceGameContent = lazyWithRetry(() => import('../games/dice'));
const DiceBetContent = lazyWithRetry(() => import('../games/dice/diceBetContent'));
const DiceGameRules = lazyWithRetry(() => import('../games/dice/diceGameRules'));
const DiceFairness = lazyWithRetry(() => import('../games/dice/diceFairness'));
const DiceAboutHash = lazyWithRetry(() => import('../games/dice/diceFairness/aboutHash'));
const DiceHotKeys = lazyWithRetry(() => import('../games/dice/diceHotKeys'));

const DoubleDiceGameContent = lazyWithRetry(() => import('../games/doubleDice'));
const DoubleDiceBetContent = lazyWithRetry(() =>
  import('../games/doubleDice/doubleDiceBetContent')
);
const DoubleDiceGameRules = lazyWithRetry(() => import('../games/doubleDice/doubleDiceGameRules'));
const DoubleDiceFairness = lazyWithRetry(() => import('../games/doubleDice/doubleDiceFairness'));
const DoubleDiceAboutHash = lazyWithRetry(() =>
  import('../games/doubleDice/doubleDiceFairness/aboutHash')
);
const DoubleDiceHotKeys = lazyWithRetry(() => import('../games/doubleDice/doubleDiceHotKeys'));

const HiloGameContent = lazyWithRetry(() => import('../games/hilo'));
const HiloBetContent = lazyWithRetry(() => import('../games/hilo/hiloBetContent'));
const HiloGameRules = lazyWithRetry(() => import('../games/hilo/hiloGameRules'));
const HiloFairness = lazyWithRetry(() => import('../games/hilo/hiloFairness'));
const HiloAboutHash = lazyWithRetry(() => import('../games/hilo/hiloFairness/aboutHash'));
const HiloHotKeys = lazyWithRetry(() => import('../games/hilo/hiloHotKeys'));

const AlternativeDiceGameContent = lazyWithRetry(() => import('../games/alternativeDice'));
const AlternativeDiceBetContent = lazyWithRetry(() =>
  import('../games/alternativeDice/alternativeDiceBetContent')
);
const AlternativeDiceGameRules = lazyWithRetry(() =>
  import('../games/alternativeDice/alternativeDiceGameRules')
);
const AlternativeDiceFairness = lazyWithRetry(() =>
  import('../games/alternativeDice/alternativeDiceFairness')
);
const AlternativeDiceAboutHash = lazyWithRetry(() =>
  import('../games/alternativeDice/alternativeDiceFairness/aboutHash')
);
const AlternativeDiceHotKeys = lazyWithRetry(() =>
  import('../games/alternativeDice/alternativeDiceHotKeys')
);

const BlackJackGameContent = lazyWithRetry(() => import('../games/blackjack'));
const BlackJackBetContent = lazyWithRetry(() => import('../games/blackjack/blackJackBetContent'));
const BlackJackGameRules = lazyWithRetry(() => import('../games/blackjack/blackJackGameRules'));
const BlackJackFairness = lazyWithRetry(() => import('../games/blackjack/blackJackFairness'));
const BlackJackAboutHash = lazyWithRetry(() =>
  import('../games/blackjack/blackJackFairness/aboutHash')
);
const BlackJackHotKeys = lazyWithRetry(() => import('../games/blackjack/blackJackHotKeys'));

const PlinkoGameContent = lazyWithRetry(() => import('../games/plinko'));
const PlinkoBetContent = lazyWithRetry(() => import('../games/plinko/plinkoBetContent'));
const PlinkoGameRules = lazyWithRetry(() => import('../games/plinko/plinkoGameRules'));
const PlinkoFairness = lazyWithRetry(() => import('../games/plinko/plinkoFairness'));
const PlinkoAboutHash = lazyWithRetry(() => import('../games/plinko/plinkoFairness/aboutHash'));
const PlinkoHotKeys = lazyWithRetry(() => import('../games/plinko/plinkoHotKeys'));

const KenoGameContent = lazyWithRetry(() => import('../games/keno'));
const KenoBetContent = lazyWithRetry(() => import('../games/keno/kenoBetContent'));
const KenoGameRules = lazyWithRetry(() => import('../games/keno/kenoGameRules'));
const KenoFairness = lazyWithRetry(() => import('../games/keno/kenoFairness'));
const KenoAboutHash = lazyWithRetry(() => import('../games/keno/kenoFairness/aboutHash'));
const KenoHotKeys = lazyWithRetry(() => import('../games/keno/kenoHotKeys'));

const WheelGameContent = lazyWithRetry(() => import('../games/wheel'));
const WheelBetContent = lazyWithRetry(() => import('../games/wheel/wheelBetContent'));
const WheelGameRules = lazyWithRetry(() => import('../games/wheel/wheelGameRules'));
const WheelFairness = lazyWithRetry(() => import('../games/wheel/wheelFairness'));
const WheelAboutHash = lazyWithRetry(() => import('../games/wheel/wheelFairness/aboutHash'));
const WheelHotKeys = lazyWithRetry(() => import('../games/wheel/wheelHotKeys'));

const CrashGameContent = lazyWithRetry(() => import('../games/crash'));
const CrashBetContent = lazyWithRetry(() => import('../games/crash/crashBetContent'));
const CrashGameRules = lazyWithRetry(() => import('../games/crash/crashGameRules'));
const CrashFairness = lazyWithRetry(() => import('../games/crash/crashFairness'));
const CrashAboutHash = lazyWithRetry(() => import('../games/crash/crashFairness/aboutHash'));
const CrashHotKeys = lazyWithRetry(() => import('../games/crash/crashHotKeys'));

const CoinFlipGameContent = lazyWithRetry(() => import('../games/coinFlip'));
const CoinFlipBetContent = lazyWithRetry(() => import('../games/coinFlip/coinFlipBetContent'));
const CoinFlipGameRules = lazyWithRetry(() => import('../games/coinFlip/coinFlipGameRules'));
const CoinFlipFairness = lazyWithRetry(() => import('../games/coinFlip/coinFlipFairness'));
const CoinFlipAboutHash = lazyWithRetry(() =>
  import('../games/coinFlip/coinFlipFairness/aboutHash')
);
const CoinFlipHotKeys = lazyWithRetry(() => import('../games/coinFlip/coinFlipHotKeys'));

const FootballGameContent = lazyWithRetry(() => import('../games/football'));
const FootballBetContent = lazyWithRetry(() => import('../games/football/footballBetContent'));
const FootballGameRules = lazyWithRetry(() => import('../games/football/footballGameRules'));
const FootballFairness = lazyWithRetry(() => import('../games/football/footballFairness'));
const FootballAboutHash = lazyWithRetry(() =>
  import('../games/football/footballFairness/aboutHash')
);
const FootballHotKeys = lazyWithRetry(() => import('../games/football/footballHotKeys'));

const FishingGameContent = lazyWithRetry(() => import('../games/fishing'));
const FishingBetContent = lazyWithRetry(() => import('../games/fishing/fishingBetContent'));
const FishingGameRules = lazyWithRetry(() => import('../games/fishing/fishingGameRules'));
const FishingFairness = lazyWithRetry(() => import('../games/fishing/fishingFairness'));
const FishingAboutHash = lazyWithRetry(() => import('../games/fishing/fishingFairness/aboutHash'));
const FishingHotKeys = lazyWithRetry(() => import('../games/fishing/fishingHotKeys'));

const DriftGameContent = lazyWithRetry(() => import('../games/drift'));
const DriftBetContent = lazyWithRetry(() => import('../games/drift/driftBetContent'));
const DriftGameRules = lazyWithRetry(() => import('../games/drift/driftGameRules'));
const DriftFairness = lazyWithRetry(() => import('../games/drift/driftFairness'));
const DriftAboutHash = lazyWithRetry(() => import('../games/drift/driftFairness/aboutHash'));
const DriftHotKeys = lazyWithRetry(() => import('../games/drift/driftHotKeys'));

const RouletteGameContent = lazyWithRetry(() => import('../games/roulette'));
const RouletteBetContent = lazyWithRetry(() => import('../games/roulette/rouletteBetContent'));
const RouletteGameRules = lazyWithRetry(() => import('../games/roulette/rouletteGameRules'));
const RouletteFairness = lazyWithRetry(() => import('../games/roulette/rouletteFairness'));
const RouletteAboutHash = lazyWithRetry(() =>
  import('../games/roulette/rouletteFairness/aboutHash')
);
const RouletteHotKeys = lazyWithRetry(() => import('../games/roulette/rouletteHotKeys'));

const BaccaratGameContent = lazyWithRetry(() => import('../games/baccarat'));
const BaccaratBetContent = lazyWithRetry(() => import('../games/baccarat/baccaratBetContent'));
const BaccaratGameRules = lazyWithRetry(() => import('../games/baccarat/baccaratGameRules'));
const BaccaratFairness = lazyWithRetry(() => import('../games/baccarat/baccaratFairness'));
const BaccaratAboutHash = lazyWithRetry(() =>
  import('../games/baccarat/baccaratFairness/aboutHash')
);
const BaccaratHotKeys = lazyWithRetry(() => import('../games/baccarat/baccaratHotKeys'));

const FastTradeGameContent = lazyWithRetry(() => import('../games/fastTrade'));
const FastTradeBetContent = lazyWithRetry(() => import('../games/fastTrade/fastTradeBetContent'));
const FastTradeGameRules = lazyWithRetry(() => import('../games/fastTrade/fastTradeGameRules'));
const FastTradeFairness = lazyWithRetry(() => import('../games/fastTrade/fastTradeFairness'));
const FastTradeAboutHash = lazyWithRetry(() =>
  import('../games/fastTrade/fastTradeFairness/aboutHash')
);
const FastTradeHotKeys = lazyWithRetry(() => import('../games/fastTrade/fastTradeHotKeys'));

const HandBlackJackGameContent = lazyWithRetry(() => import('../games/handBlackjack'));
const HandBlackJackBetContent = lazyWithRetry(() =>
  import('../games/handBlackjack/handBlackjackBetContent')
);
const HandBlackJackGameRules = lazyWithRetry(() =>
  import('../games/handBlackjack/handBlackjackGameRules')
);
const HandBlackJackFairness = lazyWithRetry(() =>
  import('../games/handBlackjack/handBlackjackFairness')
);
const HandBlackJackAboutHash = lazyWithRetry(() =>
  import('../games/handBlackjack/handBlackjackFairness/aboutHash')
);
const HandBlackJackHotKeys = lazyWithRetry(() =>
  import('../games/handBlackjack/handBlackjackHotKeys')
);

const TowerGameContent = lazyWithRetry(() => import('../games/tower'));
const TowerBetContent = lazyWithRetry(() => import('../games/tower/towerBetContent'));
const TowerGameRules = lazyWithRetry(() => import('../games/tower/towerGameRules'));
const TowerFairness = lazyWithRetry(() => import('../games/tower/towerFairness'));
const TowerAboutHash = lazyWithRetry(() => import('../games/tower/towerFairness/aboutHash'));
const TowerHotKeys = lazyWithRetry(() => import('../games/tower/towerHotKeys'));

const PowerOfGodsGameContent = lazyWithRetry(() => import('../games/powerOfGods'));
const PowerOfGodsBetContent = lazyWithRetry(() =>
  import('../games/powerOfGods/powerOfGodsBetContent')
);
const PowerOfGodsGameRules = lazyWithRetry(() =>
  import('../games/powerOfGods/powerOfGodsGameRules')
);
const PowerOfGodsFairness = lazyWithRetry(() => import('../games/powerOfGods/powerOfGodsFairness'));
const PowerOfGodsAboutHash = lazyWithRetry(() =>
  import('../games/powerOfGods/powerOfGodsFairness/aboutHash')
);
const PowerOfGodsHotKeys = lazyWithRetry(() => import('../games/powerOfGods/powerOfGodsHotKeys'));

const rootRoutes = [
  {
    path: '/crypto-baccarat/',
    name: TranslationKeys.Baccarat,
    gameContent: BaccaratGameContent,
    betContent: BaccaratBetContent,
    gameRulesContent: BaccaratGameRules,
    fairnessResultContent: BaccaratFairness,
    aboutHashContent: BaccaratAboutHash,
    hotKeysContent: BaccaratHotKeys,
    exact: true,
    gameId: GameIds.Baccarat,
  },
  {
    path: '/crypto-roulette/',
    name: TranslationKeys.Roulette,
    gameContent: RouletteGameContent,
    betContent: RouletteBetContent,
    gameRulesContent: RouletteGameRules,
    fairnessResultContent: RouletteFairness,
    aboutHashContent: RouletteAboutHash,
    hotKeysContent: RouletteHotKeys,
    exact: true,
    gameId: GameIds.Roulette,
  },
  {
    path: '/crypto-drift/',
    name: TranslationKeys.Drift,
    gameContent: DriftGameContent,
    betContent: DriftBetContent,
    gameRulesContent: DriftGameRules,
    fairnessResultContent: DriftFairness,
    aboutHashContent: DriftAboutHash,
    hotKeysContent: DriftHotKeys,
    exact: true,
    gameId: GameIds.Drift,
  },
  {
    path: '/crypto-football/',
    name: TranslationKeys.Football,
    gameContent: FootballGameContent,
    betContent: FootballBetContent,
    gameRulesContent: FootballGameRules,
    fairnessResultContent: FootballFairness,
    aboutHashContent: FootballAboutHash,
    hotKeysContent: FootballHotKeys,
    exact: true,
    gameId: GameIds.Football,
  },
  {
    path: '/crypto-fishing/',
    name: TranslationKeys.Fishing,
    gameContent: FishingGameContent,
    betContent: FishingBetContent,
    gameRulesContent: FishingGameRules,
    fairnessResultContent: FishingFairness,
    aboutHashContent: FishingAboutHash,
    hotKeysContent: FishingHotKeys,
    exact: true,
    gameId: GameIds.Fishing,
  },
  {
    path: '/crypto-coinflip/',
    name: TranslationKeys.CoinFlip,
    gameContent: CoinFlipGameContent,
    betContent: CoinFlipBetContent,
    gameRulesContent: CoinFlipGameRules,
    fairnessResultContent: CoinFlipFairness,
    aboutHashContent: CoinFlipAboutHash,
    hotKeysContent: CoinFlipHotKeys,
    exact: true,
    gameId: GameIds.CoinFlip,
  },
  {
    path: '/crypto-crash/',
    name: TranslationKeys.Crash,
    gameContent: CrashGameContent,
    betContent: CrashBetContent,
    gameRulesContent: CrashGameRules,
    fairnessResultContent: CrashFairness,
    aboutHashContent: CrashAboutHash,
    hotKeysContent: CrashHotKeys,
    exact: true,
    gameId: GameIds.Crash,
  },
  {
    path: '/crypto-wheel/',
    name: TranslationKeys.Wheel,
    gameContent: WheelGameContent,
    betContent: WheelBetContent,
    gameRulesContent: WheelGameRules,
    fairnessResultContent: WheelFairness,
    aboutHashContent: WheelAboutHash,
    hotKeysContent: WheelHotKeys,
    exact: true,
    gameId: GameIds.Wheel,
  },
  {
    path: '/crypto-keno/',
    name: TranslationKeys.Keno,
    gameContent: KenoGameContent,
    betContent: KenoBetContent,
    gameRulesContent: KenoGameRules,
    fairnessResultContent: KenoFairness,
    aboutHashContent: KenoAboutHash,
    hotKeysContent: KenoHotKeys,
    exact: true,
    gameId: GameIds.Keno,
  },
  {
    path: '/crypto-limbo/',
    name: TranslationKeys.Limbo,
    gameContent: LimboGameContent,
    betContent: LimboBetContent,
    gameRulesContent: LimboGameRules,
    fairnessResultContent: LimboFairness,
    aboutHashContent: LimboAboutHash,
    hotKeysContent: LimboHotKeys,
    exact: true,
    gameId: GameIds.Limbo,
  },
  {
    path: '/crypto-10limbo/',
    name: TranslationKeys.Limbo10,
    gameContent: Limbo10GameContent,
    betContent: Limbo10BetContent,
    gameRulesContent: Limbo10GameRules,
    fairnessResultContent: Limbo10Fairness,
    aboutHashContent: Limbo10AboutHash,
    hotKeysContent: Limbo10HotKeys,
    exact: true,
    gameId: GameIds.Limbo10,
  },
  {
    path: '/crypto-mines/',
    name: TranslationKeys.Mines,
    gameContent: MinesGameContent,
    betContent: MinesBetContent,
    gameRulesContent: MinesGameRules,
    fairnessResultContent: MinesFairness,
    aboutHashContent: MinesAboutHash,
    hotKeysContent: MinesHotKeys,
    exact: true,
    gameId: GameIds.Mines,
  },
  {
    path: '/crypto-dice/',
    name: TranslationKeys.Dice,
    gameContent: DiceGameContent,
    betContent: DiceBetContent,
    gameRulesContent: DiceGameRules,
    fairnessResultContent: DiceFairness,
    aboutHashContent: DiceAboutHash,
    hotKeysContent: DiceHotKeys,
    exact: true,
    gameId: GameIds.Dice,
  },
  {
    path: '/crypto-double-dice/',
    name: TranslationKeys.DoubleDice,
    gameContent: DoubleDiceGameContent,
    betContent: DoubleDiceBetContent,
    gameRulesContent: DoubleDiceGameRules,
    fairnessResultContent: DoubleDiceFairness,
    aboutHashContent: DoubleDiceAboutHash,
    hotKeysContent: DoubleDiceHotKeys,
    exact: true,
    gameId: GameIds.DoubleDice,
  },
  {
    path: '/crypto-hilo/',
    name: TranslationKeys.Hilo,
    gameContent: HiloGameContent,
    betContent: HiloBetContent,
    gameRulesContent: HiloGameRules,
    fairnessResultContent: HiloFairness,
    aboutHashContent: HiloAboutHash,
    hotKeysContent: HiloHotKeys,
    exact: true,
    gameId: GameIds.Hilo,
  },
  {
    path: '/crypto-ultimatedice/',
    name: TranslationKeys.AlternativeDice,
    gameContent: AlternativeDiceGameContent,
    betContent: AlternativeDiceBetContent,
    gameRulesContent: AlternativeDiceGameRules,
    fairnessResultContent: AlternativeDiceFairness,
    aboutHashContent: AlternativeDiceAboutHash,
    hotKeysContent: AlternativeDiceHotKeys,
    exact: true,
    gameId: GameIds.AlternativeDice,
  },
  {
    path: '/crypto-blackjack/',
    name: TranslationKeys.BlackJack,
    gameContent: BlackJackGameContent,
    betContent: BlackJackBetContent,
    gameRulesContent: BlackJackGameRules,
    fairnessResultContent: BlackJackFairness,
    aboutHashContent: BlackJackAboutHash,
    hotKeysContent: BlackJackHotKeys,
    exact: true,
    gameId: GameIds.BlackJack,
  },
  {
    path: '/crypto-plinko/',
    name: TranslationKeys.Plinko,
    gameContent: PlinkoGameContent,
    betContent: PlinkoBetContent,
    gameRulesContent: PlinkoGameRules,
    fairnessResultContent: PlinkoFairness,
    aboutHashContent: PlinkoAboutHash,
    hotKeysContent: PlinkoHotKeys,
    exact: true,
    gameId: GameIds.Plinko,
  },
  {
    path: '/crypto-fasttrade/',
    name: TranslationKeys.FastTrade,
    gameContent: FastTradeGameContent,
    betContent: FastTradeBetContent,
    gameRulesContent: FastTradeGameRules,
    fairnessResultContent: FastTradeFairness,
    aboutHashContent: FastTradeAboutHash,
    hotKeysContent: FastTradeHotKeys,
    exact: true,
    gameId: GameIds.FastTrade,
  },
  {
    path: '/crypto-handsblackjack/',
    name: TranslationKeys.HandBlackJack,
    gameContent: HandBlackJackGameContent,
    betContent: HandBlackJackBetContent,
    gameRulesContent: HandBlackJackGameRules,
    fairnessResultContent: HandBlackJackFairness,
    aboutHashContent: HandBlackJackAboutHash,
    hotKeysContent: HandBlackJackHotKeys,
    exact: true,
    gameId: GameIds.HandBlackJack,
  },
  {
    path: '/crypto-tower/',
    name: TranslationKeys.Tower,
    gameContent: TowerGameContent,
    betContent: TowerBetContent,
    gameRulesContent: TowerGameRules,
    fairnessResultContent: TowerFairness,
    aboutHashContent: TowerAboutHash,
    hotKeysContent: TowerHotKeys,
    exact: true,
    gameId: GameIds.Tower,
  },
  {
    path: '/crypto-powerofgods/',
    name: TranslationKeys.PowerOfGods,
    gameContent: PowerOfGodsGameContent,
    betContent: PowerOfGodsBetContent,
    gameRulesContent: PowerOfGodsGameRules,
    fairnessResultContent: PowerOfGodsFairness,
    aboutHashContent: PowerOfGodsAboutHash,
    hotKeysContent: PowerOfGodsHotKeys,
    exact: true,
    gameId: GameIds.PowerOfGods,
  },
];

export default rootRoutes;
